<template >
    <v-dialog v-model="$store.state.mudarturma" max-width="600px">

  <!-- Cartão principal com sombra mais suave -->
  <v-card elevation="1" class="rounded-lg">
    <!-- Cabeçalho com gradiente -->
    <v-card-title class="black--text primary-gradient py-4">
      <v-icon left dark>mdi-account-switch</v-icon>
      <span class="text-h5 font-weight-bold">Mudança de Turma </span>
    </v-card-title>

    <v-card-text class="pa-6">
      <!-- Seção: Informações do Estudante -->
      <div class="mb-6">
        <div class="d-flex align-center mb-3">
          <v-icon color="primary" left>mdi-account-details</v-icon>
          <span class="text-h6 primary--text">Informações do Estudante</span>
        </div>
        
        <v-row dense>
          <v-col cols="12" md="6">
            <v-card outlined class="pa-3 rounded-lg" color="grey lighten-5">
              <div class="d-flex align-center">
                <v-avatar color="primary lighten-2" size="30" class="mr-3">
                  <v-icon dark>mdi-account</v-icon>
                </v-avatar>
                <div>
                  <div class="text-caption grey--text">Nome do Estudante</div>
                  <div class="text-subtitle-3 font-weight-medium">{{ estudante.nome }}</div>
                </div>
              </div>
            </v-card>
          </v-col>

           <v-col cols="12" md="6">
            <v-card outlined class="pa-3 rounded-lg" color="grey lighten-5">
              <div class="d-flex align-center">
                <v-avatar color="indigo lighten-2" size="30" class="mr-3">
                  <v-icon dark>mdi-notebook-outline</v-icon>
                </v-avatar>
                <div>
                  <div class="text-caption grey--text">Curso</div>
                  <div class="text-subtitle-3 font-weight-medium">{{ estudante.curso }}</div>
                </div>
              </div>
            </v-card>
          </v-col>

           <v-col cols="12" md="6">
            <v-card outlined class="pa-3 rounded-lg" color="grey lighten-5">
              <div class="d-flex align-center">
                <v-avatar color="indigo lighten-2" size="30" class="mr-3">
                  <v-icon dark>mdi-notebook-outline</v-icon>
                </v-avatar>
                <div>
                  <div class="text-caption grey--text">Classe</div>
                  <div class="text-subtitle-3 font-weight-medium">{{ utilitarios.descricaoClasse(estudante.idAno_Academico) }}</div>
                </div>
              </div>
            </v-card>
          </v-col>
          
          <v-col cols="12" md="6">
            <v-card outlined class="pa-3 rounded-lg" color="grey lighten-5">
              <div class="d-flex align-center">
                <v-avatar color="indigo lighten-2" size="30" class="mr-3">
                  <v-icon dark>mdi-school</v-icon>
                </v-avatar>
                <div>
                  <div class="text-caption grey--text">Turma Atual</div>
                  <div class="text-subtitle-3 font-weight-medium">{{ estudante.turma }}</div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <v-divider class="my-4" style="border-color: rgba(0,0,0,0.08)"></v-divider>

      <!-- Seção: Nova Turma -->
      <div class="mt-6">
        <div class="d-flex align-center mb-3">
          <v-icon color="teal" left>mdi-arrow-right-bold-circle</v-icon>
          <span class="text-h6 teal--text">Seleção da Nova Turma</span>
        </div>
        
        <v-row dense>
            <v-col cols="12" md="2">
            </v-col>
          <v-col cols="12" md="8">
            <v-select
              v-model="turma_selecionada"
              :items="turmasFiltered"
              item-value="pkTurma"
              item-text="turmadescricao"
              label="Nova Turma"
              outlined
              dense
              return-object
              prepend-inner-icon="mdi-google-classroom"
              color="primary"
              class="rounded-lg"
            ></v-select>
          </v-col>
        </v-row>

      </div>
    </v-card-text>

    <!-- Ações com melhor espaçamento -->
    <v-card-actions class="pa-4 px-5">
      <v-btn 
        color="grey darken-1" 
        text 
        @click="fecharComponente"
        class="px-6 rounded-pill"
        large
      >
        <v-icon left>mdi-close</v-icon> Fechar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn 
        color="success" 
        :disabled="turma_selecionada === null"
        dark 
        @click="finalizarMudanca()"
        class="px-1 rounded-pill"
        large
        :loading="overlay"
      >
        <v-icon left>mdi-check-all</v-icon> Confirmar Mudança
      </v-btn>
    </v-card-actions>
  </v-card>
    </v-dialog>

</template>
<script>
import _axios from '../../../../plugins/axios'
import Swal from 'sweetalert2';
import utilitarios from '../../../../plugins/utilitarios';
const ls = require('local-storage')
export default {
    name: 'mudarTurmaEst',
    props: ['estudante'],

    data: () => ({
        turmasFiltered: [],
        turmasAllAnoLectivo: [],
        Listaranoslectivo: [],
        utilitarios:utilitarios,
        anoLectivoSelected: undefined,
        turma_selecionada: null,
        showResult: false,
        color: '',
        result: '',
        overlay: false
    }),

    computed:{
         
  anolectivo(){
      return ls.get('anolectivo')
    }
    },

    created() {
        this.initializeturmasAllAnolectivo();         
    },

    methods: {
        async AnosLectivoAll() {
            this.overlay = true;
            try {
                this.Listaranoslectivo = await _axios.get('/listarAnoLectivoAll').then(res => res.data)
            } catch (error) {
                this.text = error
                this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
            } finally {
                this.overlay = false
            }
        },

        fecharComponente (){
           this.$store.dispatch('toggleMudarTurma', false); // abrir
          
        },

        async initializeturmasAllAnolectivo() {
          
            this.turma_selecionada = null
            this.turmasFiltered = []
            try {
                this.turmasAllAnoLectivo = await _axios.get('/turmaFindAllAno/' + this.anolectivo).then(res => res.data)
                this.turmasFiltered = this.turmasAllAnoLectivo.filter(t => t.idCurso === this.estudante.idCurso && t.idAno_Academico === parseInt(this.estudante.idAno_Academico))         
                                
            } catch (error) {              
                this.text = error
                this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
            } finally {
                this.isLoading = false
            }
        },

        async finalizarMudanca() {
            if (this.turma_selecionada) {

              this.overlay = true;
                // Preparar os dados para a requisição  
                
                let dados = {
                    matricula: this.estudante.idMatricula,
                    pkTurma: this.turma_selecionada.pkTurma,
                    idTurma: this.turma_selecionada.idTurma,
                    pkInscricao_na_turma: this.estudante.pkInscricao_na_turma
                }

                // Enviar a requisição para mudar a turma
                try {
                    this.overlay = true;
                    let response = await _axios.post('/mudarTurma_', dados).then((res) => res)                    
                    if (response.data.affectedRows > 0) {
                        Swal.fire('Sucesso', 'Turma Alterada com sucesso!', 'success')
                        this.fecharComponente()
                    }else {
                        Swal.fire('Atenção', 'Nenhuma alteração foi feita!', 'info')
                    }
                } catch (error) {
                    Swal.fire('Error', 'Ocorreu um erro durante a mudança de turma!', 'error');
                } finally {
                    this.overlay = false;
                }
            } else {
                this.showResult = true;
                this.result = 'Preencha os camps vázios!'
                this.color = "yellow"
            }
        },
     
    }
}
</script>
<style>
 
 
</style>